
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-welfare",
      function () {
        return require("private-next-pages/public-welfare.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-welfare"])
      });
    }
  